/**
 * The sketch store schema: tldraw's default shapes and bindings plus the
 * drafting shapes. One definition, used for headless validation on the API VM
 * and (in the app) as the schema behind createTLStore, so both write paths
 * agree on what a sketch may contain.
 *
 * The defaults include `note`, tldraw's sticky, which nothing authors any
 * more: the callout replaced it. It stays in the schema so sketches drawn
 * when it existed still load and read.
 */
import {
  createTLSchema,
  defaultBindingSchemas,
  defaultShapeSchemas,
  type TLSchema,
} from "@tldraw/tlschema";

import {
  calloutBindingProps,
  calloutMigrations,
  calloutProps,
} from "./shapes/callout";
import { dimBindingProps, dimMigrations, dimProps } from "./shapes/dim";
import { gridlineProps } from "./shapes/gridline";

export const sketchShapeSchemas = {
  ...defaultShapeSchemas,
  gridline: { props: gridlineProps },
  dim: { props: dimProps, migrations: dimMigrations },
  callout: { props: calloutProps, migrations: calloutMigrations },
};

export const sketchBindingSchemas = {
  ...defaultBindingSchemas,
  dim: { props: dimBindingProps },
  callout: { props: calloutBindingProps },
};

export function createSketchSchema(): TLSchema {
  return createTLSchema({
    shapes: sketchShapeSchemas,
    bindings: sketchBindingSchemas,
  });
}

let singleton: TLSchema | null = null;

/** The shared schema instance behind every headless read and write. */
export function sketchSchema(): TLSchema {
  singleton ??= createSketchSchema();
  return singleton;
}
